document.addEventListener('DOMContentLoaded', function() {
    // ✅ Only run if an element with ID or class is present:
    const pageCondition = document.querySelector('.single-post');
    if (!pageCondition) {
      return; // Exit early if page condition is not met
    }
    const links = document.querySelectorAll('#content a[href]');

    links.forEach(link => {
      const linkUrl = new URL(link.href, window.location.origin);
      const linkHost = linkUrl.hostname;

      if (linkHost !== window.location.hostname) {
        link.classList.add('external-link');

        if (link.target !== '_blank') {
          link.setAttribute('target', '_blank');
        }

        const rel = link.getAttribute('rel') || '';
        let newRel = rel;

        if (!rel.includes('noopener')) {
          newRel += ' noopener';
        }
        if (!rel.includes('noreferrer')) {
          newRel += ' noreferrer';
        }
        link.setAttribute('rel', newRel.trim());
      }
    });
  });